import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';

/**
 * Generated class for the CertifyingagencyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-certifyingagency',
  templateUrl: 'certifyingagency.html',
})
export class CertifyingagencyPage {
  allcountrys: any; agenyname: any; rfqname: any; rfqemail: any; rfqmobile: any; rfqcountry_nm: any; filteredcountry: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private apiProvider: ApiProvider,public viewCtrl:ViewController) {
    this.getallCountry();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CertifyingagencyPage');
  }
  getallCountry() {
    this.apiProvider.getallCountrys().subscribe((res: any) => {
      this.allcountrys = res.data;
    }, er => {
      console.log(er);
    })
  }

  submitdata(rfqname, rfqemail, rfqmobile, rfqcountry_nm) {
    const country = JSON.parse(localStorage.getItem('user_data'));
    var data = {
      'rfqname': rfqname,
      'rfqemail': rfqemail,
      'rfqmobile': rfqmobile,
      'rfqcountry_nm': this.filteredcountry,
      'rfqusr_id': country[0].usr_id,
      'indicator': 2,
    }
    console.log(data);


    this.apiProvider.certifyingagencies(data).subscribe((res: any) => {
      if (res.status == 200) {
        this.agenyname = ''; this.rfqname = ''; this.rfqemail = ''; this.rfqmobile = ''; this.rfqcountry_nm = '';
        // this.validationform.value.lead_certifying_agency='';
        this.viewCtrl.dismiss(res.status);
      }
    }, er => {
      console.log(er);
    })
  }

  countryfilterdata(data) {

    console.log(data);
    this.filteredcountry = data.value.country_nm
    console.log(this.filteredcountry);
  }
 


}



// WEBPACK FOOTER //
// ./src/pages/certifyingagency/certifyingagency.ts